@import 'src/styles/variabels';
@import 'src/styles/mobile';

.root {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: $mobile-space-xs;
  flex: none;
  button {
    width: $mobile-tap-dense;
    height: $mobile-tap-dense;
  }
}

.state {
  font-size: $mobile-font-value;
  white-space: nowrap;
  color: $color-default;
}
